import { Skeleton } from "src/components/ui/skeleton";

export default function SkeletonTable() {
  return (
    <div className="pt-4 space-y-5">
      <div className="flex items-center gap-2 justify-between">
        <Skeleton className="h-8 w-1/4" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <div className="border p-2 rounded-lg shadow-sm">
        <div className="flex items-center gap-5 border-b pb-2">
          {Array(8)
            .fill()
            .map((_, i) => (
              <Skeleton className="h-5 w-full" />
            ))}
        </div>
        <Skeleton className="h-40 w-full mt-2" />
      </div>
    </div>
  );
}
